import { useQuery } from "@tanstack/react-query";
import { api } from "../../../singleton/axios";
import { MySubscriptions } from "../types";

export const MY_SUBSCRIPTIONS_QUERY_KEY = ["notification-subscriptions"] as const;

/**
 * Everything the user is subscribed to, plus what they may subscribe to
 * (`topicAccess`, computed server-side). ONE cached list for the whole app:
 * every "Get alerts" button reads its state from it through `select`, so a
 * ticker page never makes a per-ticker request.
 */
export const useMySubscriptions = <TSelected = MySubscriptions>(
  select?: (data: MySubscriptions) => TSelected,
) =>
  useQuery({
    queryKey: MY_SUBSCRIPTIONS_QUERY_KEY,
    queryFn: async (): Promise<MySubscriptions> => {
      const { data } = await api.get<MySubscriptions>("/notification-subscriptions");
      return data;
    },
    select,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
